// extracted by mini-css-extract-plugin
export default {"animals_list__tag_icon_wrapper":"Tag_animals_list__tag_icon_wrapper__i41Gx","animals_list__tag_icon_text":"Tag_animals_list__tag_icon_text__V9xcu","spin":"Tag_spin__p7NCq"};